import { PersonForm } from '~domains/profile/widgets/person-form';

export const ProfilePage = () => {
  return <PersonForm />;
};
